import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { supabase } from '../lib/supabaseClient';
import "./style/team.css";

const fallbackTeamList = [
  {
    image_url: "/assets/edc rmv (1).png",
    first_name: "Edwina",
    last_name: "Di",
    positions: ["Founder"],
    is_founder: true,
  },
  {
    image_url: "/assets/nerly.png",
    first_name: "Nerly",
    last_name: "",
    positions: ["KOL Specialist"],
  },
  {
    image_url: "/assets/edc rmv (2).png",
    first_name: "Amalia",
    last_name: "Syahrani",
    positions: ["Art Director"],
  },
  {
    image_url: "/assets/edc rmv (3).png",
    first_name: "Rizal",
    last_name: "Renaldy",
    positions: ["Graphic Designer"],
  },
  {
    image_url: "/assets/hana.png",
    first_name: "Hana",
    last_name: "",
    positions: ["Personal Assistent"],
  },
  {
    image_url: "/assets/vert.png",
    first_name: "Vert",
    last_name: "",
    positions: ["Photographer"],
  },
  {
    image_url: "/assets/nia.png",
    first_name: "Nia",
    last_name: "",
    positions: ["Content Creator & Host Live"],
  },
  {
    image_url: "/assets/naomi.png",
    first_name: "Naomi",
    last_name: "",
    positions: ["Content Creator"],
  },
  {
    image_url: "/assets/martin.png",
    first_name: "Martin",
    last_name: "",
    positions: ["Social Media Specialist"],
  },
  {
    image_url: "/assets/kia.png",
    first_name: "Kia",
    last_name: "",
    positions: ["Stylist"],
  },
  {
    image_url: "/assets/akhsal.png",
    first_name: "Akhsal",
    last_name: "",
    positions: ["Stylist"],
  },
];

export default function TeamSection() {
  const [teamList, setTeamList] = useState(fallbackTeamList);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
    fetchTeams();
  }, []);

  const fetchTeams = async () => {
    try {
      const { data, error } = await supabase
        .from('teams')
        .select('*')
        .order('display_order', { ascending: true });

      if (error) throw error;

      if (data && data.length > 0) {
        setTeamList(data);
      }
    } catch (error) {
      console.log('Using fallback data:', error.message);
    }
  };

  // Ambil founder
  const founder = teamList.find(t => t.is_founder) || teamList[0];
  // Ambil sisanya (non-founder)
  const others = teamList.filter(t => !t.is_founder);

  // Safety check
  if (!founder) {
    return null;
  }

  return (
    <section id="team" className="py-5 team-section">
      <div className="container">
        <h1 className="text-center whyus-title" data-aos="fade-up">
          <span style={{ color: '#FFD54F' }}>The</span>{" "}
          <span style={{ color: '#1F2937' }}>Company </span>
          <span style={{ color: '#FFD54F' }}>Team</span>
        </h1>

        <hr className="whyus-hr" data-aos="zoom-in" data-aos-delay="200" />

        {/* ROW 1: Founder */}
        <div className="row justify-content-center mb-5">
          <div
            className="col-12 col-md-6 col-lg-4"
            data-aos="zoom-in"
            data-aos-delay="100"
          >
            <div className="team-card text-center">
              <img
                src={founder.image_url}
                alt={`${founder.first_name} ${founder.last_name || ""}`}
                className="team-img"
              />
              <div className="team-info">
                <h3>
                  {founder.first_name}{" "}
                  <span className="lastname">{founder.last_name || ""}</span>
                </h3>
                <p className="role">
                  {Array.isArray(founder.positions) 
                    ? founder.positions.join(", ") 
                    : founder.positions}
                </p>
                <p className="brand">EDC.WORKSS</p>
              </div>
            </div>
          </div>
        </div>

        {/* ROW 2: Other team */}
        <div className="row g-4 justify-content-center">
          {others.map((member, idx) => (
            <div
              key={member.id || idx}
              className="col-12 col-sm-6 col-md-4 col-lg-3"
              data-aos="zoom-in"
              data-aos-delay={idx * 200}
            >
              <div className="team-card text-center">
                <img
                  src={member.image_url}
                  alt={`${member.first_name} ${member.last_name || ""}`}
                  className="team-img"
                />
                <div className="team-info">
                  <h3>
                    {member.first_name}{" "}
                    <span className="lastname">{member.last_name || ""}</span>
                  </h3>
                  <p className="role">
                    {Array.isArray(member.positions) 
                      ? member.positions.join(", ") 
                      : member.positions}
                  </p>
                  <p className="brand">EDC.WORKSS</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
